<script setup lang="ts">
import ModalSpyCounterEspionage from '@/components/Interface/Modal/Modals/ModalSpy/ModalSpyCounterEspionage.vue'
import ModalSpyIntelligenceGathering from '@/components/Interface/Modal/Modals/ModalSpy/ModalSpyIntelligenceGathering.vue'
import ModalSpyCyberAttack from '@/components/Interface/Modal/Modals/ModalSpy/ModalSpyCyberAttack.vue'
import ModalSpyStealTechnology from '@/components/Interface/Modal/Modals/ModalSpy/ModalSpyStealTechnology.vue'
import ModalSpySabotageShips from '@/components/Interface/Modal/Modals/ModalSpy/ModalSpySabotageShips.vue'
import ModalSpyAssassinate from '@/components/Interface/Modal/Modals/ModalSpy/ModalSpyAssassinate.vue'
import ModalSpyTraining from '@/components/Interface/Modal/Modals/ModalSpy/ModalSpyTraining.vue'

/**
 * Props
 */
defineProps({
  spy: {
    type: Object,
    required: true
  },
  type: {
    type: String,
    required: true
  }
})
</script>

<template>
  <ModalSpyCounterEspionage v-if="spy.mission === 'counter_espionage'" :spy="spy" :type="type" />
  <ModalSpyIntelligenceGathering
    v-else-if="spy.mission === 'intelligence_gathering'"
    :spy="spy"
    :type="type"
  />
  <ModalSpyCyberAttack v-else-if="spy.mission === 'cyber_attack'" :spy="spy" :type="type" />
  <ModalSpyStealTechnology v-else-if="spy.mission === 'steal_technology'" :spy="spy" :type="type" />
  <!--  <ModalSpySabotagePlanet v-else-if="spy.mission === 'sabotage_planet'" :spy="spy" :type="type"/>-->
  <ModalSpySabotageShips v-else-if="spy.mission === 'sabotage_ships'" :spy="spy" :type="type" />
  <ModalSpyAssassinate v-else-if="spy.mission === 'assassinate'" :spy="spy" :type="type" />
  <ModalSpyTraining v-else-if="spy.mission === 'training'" :spy="spy" :type="type" />
</template>

<style scoped lang="scss"></style>
